const config = {
    apiUrl: process.env.VUE_APP_API_URL || (process.env.NODE_ENV === 'production' ? 'https://api-acktrails.com' : '/api-proxy'),
    mapboxAccessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN || 'pk.eyJ1IjoibmFudHVja2V0IiwiYSI6ImNsdndlaDNoYzI3MDkycnFpcTF6NHY3N28ifQ.li7SqKrAmbmtGDfo4bOIvw',
    analyticUrl: process.env.VUE_APP_ANALYTIC_URL || 'http://analytic.acktrails.com',
    imageDropzoneUrl: process.env.VUE_APP_IMAGE_DROPZONE_URL || 'https://httpbin.org/post'
};

export default config;
